import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import RightSidebar from './../../components/templates/rightsidebar.vue'; 
import LeftSidebar from './../../components/templates/leftsidebar.vue';  
import SearchBox from './../../components/templates/searchbox.vue'; 
import ActiveProducts from './../../components/widgets/activeproducts.vue'; 


let service = new services();
export default {
    name: 'Search',
    data () {
        return {
            user:{},
            products: {},
            product: {},
            search_data:"",
            loggedIn: false
        }
    },
  
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'right-sidebar': RightSidebar,
        'left-sidebar': LeftSidebar,
        'search-box': SearchBox,
        'active-products':ActiveProducts,
    },
   methods: {
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                           this.user.user_id = element.user_id;
                           this.user.user_name = localStorage.getItem("sp_user");
                            this.loggedIn = true;
                        }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
               //this.$router.push('login');
            }
        },

    
        getSearchProducts(){
            service.searchProducts(this,this.$route.query.k).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.search_data = this.$route.query.k;
                }
            }).catch((err) => {})
        },

        getBusinessSearchProducts(){
            service.searchBusinessProducts(this,this.$route.query.k).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.search_data = this.$route.query.k;
                }
            }).catch((err) => {})
        },

        getCategorySearchProducts(){
            service.searchCategoryProducts(this,this.$route.query.s,this.$route.query.k).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.search_data = response.body.data_search;
                }
            }).catch((err) => {})
        },
        
    },
    created: function(){
        this.preset();
        if(this.$route.query.search == "business"){
            this.getBusinessSearchProducts();
        }else if(this.$route.query.search == "product"){
            this.getSearchProducts();
        }else if(this.$route.query.s){
            this.getCategorySearchProducts();
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/Search/script.js